import { render, staticRenderFns } from "./Comuna.vue?vue&type=template&id=239a51c2&"
import script from "./Comuna.vue?vue&type=script&lang=js&"
export * from "./Comuna.vue?vue&type=script&lang=js&"
import style0 from "./Comuna.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports